(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("__jszip"), require("__jsyaml"), require("vue"), require("$"));
	else if(typeof define === 'function' && define.amd)
		define(["__jszip", "__jsyaml", , "$"], factory);
	else if(typeof exports === 'object')
		exports["kubewarden-0.1.0"] = factory(require("__jszip"), require("__jsyaml"), require("vue"), require("$"));
	else
		root["kubewarden-0.1.0"] = factory(root["__jszip"], root["__jsyaml"], root["Vue"], root["$"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__5877__, __WEBPACK_EXTERNAL_MODULE__7838__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_c5e1__) {
return 